import { loadTranslations, setLocale } from 'react-redux-i18n'
import { getParseLocale, updateLocaleInStorage } from '../../utils/browserLocale'
import { apiContentText } from '../../api'

/**
 * Actualizar el idioma de todo el dashboard
 * @param {Object} query?
 * @param {string} query.locale
 * @param {string} query.company
 */
const updateText = (query = {}) => async (dispatch) => {
  if (!query.locale) query.locale = getParseLocale()

  return apiContentText
    .get(query)
    .then(({ data }) => {
      dispatch(loadTranslations({ [query.locale]: data.results }))
      dispatch(setLocale(query.locale))
      updateLocaleInStorage(query.locale)
    })
}

export default {
  updateText,
}
